import axios from "axios";

export const fetchCompetitionsData = (token, page = 1) => async (dispatch) => {
  dispatch({ type: "FETCH_COMPETITIONS_REQUEST" });
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/getAllCompetitions?page=${page}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    dispatch({ type: "FETCH_COMPETITIONS_SUCCESS", payload: response.data });
  } catch (error) {
    dispatch({
      type: "FETCH_COMPETITIONS_FAILURE",
      payload: error.message,
    });
  }
};
